export const OPENNETWORK_CATEGORIES_RESET_STATE = 'OPENNETWORK_CATEGORIES_RESET_STATE';
export const OPENNETWORK_CATEGORIES_CURRENT_ITEM = 'OPENNETWORK_CATEGORIES_CURRENT_ITEM';

export const OPENNETWORK_CATEGORIES_REQUEST_LOADING = 'OPENNETWORK_CATEGORIES_REQUEST_LOADING';
export const OPENNETWORK_CATEGORIES_REQUEST_SUCCESS = 'OPENNETWORK_CATEGORIES_REQUEST_SUCCESS';
export const OPENNETWORK_CATEGORIES_REQUEST_FAILED = 'OPENNETWORK_CATEGORIES_REQUEST_FAILED';

export const OPENNETWORK_CATEGORIES_CURRENT_ACTION = 'OPENNETWORK_CATEGORIES_CURRENT_ACTION';
export const OPENNETWORK_CATEGORIES_RESET_ACTION = 'OPENNETWORK_CATEGORIES_RESET_ACTION';